import React, { useContext } from "react";
import AuthLabeledTextInput from "../../components/Inputs/AuthLabeledTextInput";
import PhoneNumberInput from "../../components/Inputs/PhoneNumberInput";
import { AuthContext } from "../../AuthContext";
export default function PersonalInfoFields({ currentUser }) {
  const { tokenAvailable, authLoading, authUser } = useContext(AuthContext);

  if (authLoading) return null;
  return (
    <>
      {currentUser?.uid && tokenAvailable ? null : (
        <div className="flex flex-col sm:flex-row gap-2">
          <AuthLabeledTextInput
            label="First Name"
            maxLength={30}
            placeholder="John"
            name="first_name"
            className="my-0"
            required
          />
          <AuthLabeledTextInput
            label="Last Name"
            name="last_name"
            maxLength={20}
            placeholder="Doe"
            className="my-0"
            required
          />
        </div>
      )}
      <AuthLabeledTextInput
        label="Email Address"
        name="email"
        inputMode="email"
        maxLength={200}
        placeholder="you@example.com"
        className="my-0"
        required
        onInput={(e) => {
          // Safari on iPhone doesn't yet support <input type="email" /> validate yet - so we do our own validation here:
          let target = e.nativeEvent.target;
          if (
            !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
              target.value,
            )
          ) {
            target.setCustomValidity("Invalid email address");
          } else {
            target.setCustomValidity("");
          }
        }}
      />
      {authUser?.phone_number ? (
        <input type="hidden" name="phone" value={authUser.phone_number} />
      ) : (
        <PhoneNumberInput required />
      )}
    </>
  );
}
